import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TreeNode } from 'rsuite/esm/internals/Tree/types';
import { SelectOption } from '../../../Interfaces/PIMs';
import { TblInternalServices } from '../../../Interfaces/DataBase';
import { getTreeKey, LinearNodes } from '../../../Helper/linearToTree';
import { reset } from './errorBoundaryCounterSlice';

interface InitialState {
  apiData: LinearNodes[];
  selectedNode: TreeNode | null;
  selectedPackage?: SelectOption;
  selectedService?: TblInternalServices;
  chapterData: LinearNodes[];
  openFolderIds: string[];
}

const courseBuilderInitialValue: InitialState = {
  apiData: [],
  selectedNode: null,
  chapterData: [],
  openFolderIds: [],
};

const courseBuilderSlice = createSlice({
  name: 'courseBuilderSlice',
  initialState: courseBuilderInitialValue,
  reducers: {
    setApiData: (state, action: PayloadAction<LinearNodes[]>) => {
      const temp = [...action.payload];
      state.apiData = temp;
    },
    selectNode: (state, action: PayloadAction<TreeNode | null>) => {
      state.selectedNode = action.payload;
    },
    setCourseBuilderPackage: (
      state,
      action: PayloadAction<SelectOption | undefined>
    ) => {
      state.selectedPackage = action.payload;
    },
    setCourseBuilderService: (
      state,
      action: PayloadAction<TblInternalServices>
    ) => {
      state.selectedService = action.payload;
    },
    resetCourseBuilderService: (state) => {
      state.selectedService = undefined;
    },
    setCourseBuilderChapterData: (
      state,
      action: PayloadAction<LinearNodes[]>
    ) => {
      state.chapterData = action.payload;
    },
    setOpenFolderIds: (state, action: PayloadAction<string[]>) => {
      state.openFolderIds = action.payload;
    },
  },
});

export const {
  selectNode,
  setApiData,
  setCourseBuilderPackage,
  setCourseBuilderService,
  setCourseBuilderChapterData,
  setOpenFolderIds,
  resetCourseBuilderService,
} = courseBuilderSlice.actions;
export default courseBuilderSlice.reducer;
